import { AccountType, DeviceCouplingDTO, DeviceCouplingLeftAndRight, LatestDeviceCouplingInfo } from 'types'

export const transformCouplingInfoFromDeviceService = (
  couplingInfo: LatestDeviceCouplingInfo
): DeviceCouplingLeftAndRight & DeviceCouplingDTO => {
  if (!couplingInfo.coupling || (!couplingInfo.coupling.left && !couplingInfo.coupling.right)) {
    return { hasCoupling: false }
  }

  const isDefaultCoupling =
    couplingInfo.createdBy.type === AccountType.SYSTEM || couplingInfo.createdBy.type === AccountType.MIGRATION

  return {
    appointmentGid: couplingInfo.appointmentGid,
    createdAt: couplingInfo.createdAt,
    createdBy: couplingInfo.createdBy,
    hasCoupling: true,
    id: couplingInfo.id,
    isDefaultCoupling,
    left: couplingInfo.coupling.left,
    right: couplingInfo.coupling.right,
  }
}
